/* @flow */

export const FUNDING = {
    PAYPAL:      ('paypal' : 'paypal'),
    VENMO:       ('venmo' : 'venmo'),
    CREDIT:      ('credit' : 'credit'),
    CARD:        ('card' : 'card'),
    IDEAL:       ('ideal' : 'ideal'),
    SEPA:        ('sepa' : 'sepa'),
    BANCONTACT:  ('bancontact' : 'bancontact'),
    GIROPAY:     ('giropay' : 'giropay'),
    SOFORT:      ('sofort' : 'sofort'),
    EPS:         ('eps' : 'eps'),
    MYBANK:      ('mybank' : 'mybank'),
    P24:         ('p24' : 'p24'),
    ZIMPLER:     ('zimpler' : 'zimpler'),
    WECHATPAY:   ('wechatpay' : 'wechatpay')
};

export const CARD = {
    VISA:        ('visa' : 'visa'),
    MASTERCARD:  ('mastercard' : 'mastercard'),
    AMEX:        ('amex' : 'amex'),
    DISCOVER:    ('discover' : 'discover'),
    HIPER:       ('hiper' : 'hiper'),
    ELO:         ('elo' : 'elo'),
    JCB:         ('jcb' : 'jcb'),
    CUP:         ('cup' : 'cup')
};
